export default {
  admin_api: import.meta.env.VITE_APP_API_URL,
};
